import { Component } from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms'
import { NzCollapseModule } from 'ng-zorro-antd/collapse'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { AtomModule } from '../../atom/atom.module'
import { SocialLoginsService } from '../../service/social-logins.service'

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less'],
  standalone: true,
  imports: [AtomModule, NzLayoutModule, NzCollapseModule],
})
export class SettingsComponent {
  accounts = [
    'Connect your Xbox',
    'Connect your Google',
    'Connect your Facebook',
    'Connect your Nintendo',
    'Connect your Steam',
    'Connect your Playstation',
    'Connect your Epic Games',
    'Connect your Riot',
    'Connect your Twitch',
  ]

  siderMenu = [
    { label: 'Account', title: 'Account' },
    { label: 'Payment Settings', title: 'Payment Settings' },
    { label: 'Transactions', title: '' },
    { label: 'Support', title: 'Frequently Asked Questions' },
  ]

  activeItem = 0

  faqs = [
    {
      question: 'How can I access the rewards I just won from participation?',
      answer: 'Detailed answer here...',
    },
    {
      question: 'How can I access the rewards I just won from participation?',
      answer: 'Detailed answer here...',
    },
    {
      question: 'How can I access the rewards I just won from participation?',
      answer: 'Detailed answer here...',
    },
    {
      question: 'How can I access the rewards I just won from participation?',
      answer: 'Detailed answer here...',
    },
  ]

  transactions = [
    {
      type: 'PayPal Withdraw',
      date: 'May 10, 2024',
      time: '04:30 PM',
      transactionId: 'KWIK9X22',
      amount: '$230.00',
      status: 'Completed',
    },
    {
      type: 'PayPal Withdraw',
      date: 'May 10, 2024',
      time: '04:30 PM',
      transactionId: 'KWIK9X22',
      amount: '$230.00',
      status: 'Pending',
    },
  ]

  contactForm!: FormGroup
  paymentForm!: FormGroup

  constructor(
    private fb: FormBuilder,
    private socialLoginService: SocialLoginsService
  ) {
    this.createContactForm()
    this.createPaymentForm()
  }

  createPaymentForm() {
    this.paymentForm = this.fb.group({
      country: ['', Validators.required],
      zip: ['', Validators.required],
      city: ['', Validators.required],
      address: ['', Validators.required],
    })
  }

  createContactForm() {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      query: ['', Validators.required],
    })
  }

  submitPaymentForm() {
    if (!this.paymentForm.valid) {
      console.log(this.paymentForm.value)
      return
    }
  }

  signInWithGoogle() {
    this.socialLoginService.signInWithGoogle()
  }

  setActiveItem(index: number): void {
    this.activeItem = index
  }

  submitContactForm(): void {
    if (!this.contactForm.valid) {
      console.log(this.contactForm.value)
      return
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.paymentForm.controls
  }
}
